import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import EditIcon from '@mui/icons-material/Edit';
import Styled from './RelatedTaskDisplay.module.css';

function RelatedTaskDisplay({objData, idtype, allDataOfContact, setUpdatingTaskData, setIsPopupOpened2}) {

    let taskDataFound = false;

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginBottom: 2, fontWeight: 'bold' }}
            >
              Related Tasks
        </Typography>
        { Object.keys(objData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

            { allDataOfContact?.data && allDataOfContact.data.Tasks.records.map((taskData, index) => {

              if(taskData?.[idtype] == objData.Id) {

                taskDataFound = true;

                let taskDescription = taskData.Description;
                let taskDescriptionWords = taskDescription?.split(' ');
                if(taskDescriptionWords?.length > 12) {
                  taskDescription = taskDescriptionWords?.slice(0, 12).join(' ') + ' ...';
                }

              return <Card style={{ marginBottom: "12px", width: '100%' }}>
              <CardContent style={{ padding: "5px 10px", textAlign: "right" }}>
              <Grid container rowSpacing={1}  justifyContent="space-between">
              <Grid item>
              <Typography component="h6"
              variant="subtitle1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, marginTop: "0.2rem", textAlign: "left", color: "#1976D2", marginBottom: 0.5, fontWeight: "bold" }} >{taskData?.Subject?.length > 25 ? taskData?.Subject?.slice(0, 25)+ ' ...' : taskData.Subject}</Typography>
              </Grid>
              <Grid item>
                <EditIcon className={Styled.editPencilIcon} style={{ fontSize: "22px", cursor: "pointer" }} onClick={ () => { setUpdatingTaskData(taskData); setIsPopupOpened2(true); }} />
              </Grid>
              </Grid>
              <Typography variant="body2" color="textSecondary" align="left" lineHeight={1}>
                {taskDescription == null ? "No comments found!" : taskDescription}
              </Typography>
              <Typography sx={{ fontSize: "12px", marginTop: "8px", color: "white", padding: "2px 5px", borderRadius: "3px", backgroundColor: "#1976D2", display: "inline-block" }}>
                {taskData.ActivityDate == null ? "No Due Dates" : taskData.ActivityDate}
              </Typography>
              </CardContent>
            </Card>

              } else {
                if(allDataOfContact.data.Tasks.records.length == index+1 && !taskDataFound) {
                  return <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>
                }
                
              }

            }) }

          
         </Grid>
         </Box>
        }
  </Container>
  )
}

export default RelatedTaskDisplay